import {UcoastEl} from "@/scripts/core/UcoastEl";
import { qsOptional } from '@/scripts/core/global'

export class AnnouncementBar extends UcoastEl {
	static htmlSelector = 'announcement-bar'
	show: boolean
	el?: HTMLElement
	height?: number
	constructor() {
		super();
		this.show = this.getAttribute('data-show') === 'true';
		this.el = qsOptional('.announcement-bar', this)
		this.setAnnouncementHeight();
		if (!this.show || !this.el) {
			return;
		}
		const resizeObserver = new ResizeObserver((_: ResizeObserverEntry[]) => this.setAnnouncementHeight());
		resizeObserver.observe(this.el);
	}
	setAnnouncementHeight() {
		this.height = this.el ? this.el.offsetHeight : 0
		document.documentElement.style.setProperty('--bar-height', `${this.height}px`);
	}
}
